lowerBound